const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

function toPersianNumber(n, format = false) {
    n = n.toString();
    if (typeof n === "string") {
        for (var i = 0; i < 10; i++) {
            n = n.replaceAll(i, persianNumbers[i]);
        }
    }

    if (format) {
        n = reverseString(n).split("");
        for (let i = 0; i < (n.length - 1) / 3 - 1; i++) {
            n.splice(i * 3 + i + 3, 0, ",");
        }
        n = reverseString(n.join(""));
        if (n[0] == ",") {
            n = n.replace(",", "");
        }
    }
    return n;
}

function toEnglishNumber(n) {
    if (!n) return n;
    return n.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (a) => {
        return a.charCodeAt(0) & 0xf;
    });
}

function reverseString(str) {
    if (str === "") return "";
    else return reverseString(str.substr(1)) + str.charAt(0);
}

module.exports = { toPersianNumber, toEnglishNumber };
